import { StudentTimetable } from '../StudentTimetable';
import { useHasPermission } from '@versita/frontend/auth-web';
import { Actions } from '@versita/shared/models';
import { TimetableAdminDashboard } from '../TimetableAdminDashboard';

/**
 * Default landing page.
 * Shows the timetable for the logged-in student or a Admin Dashboard for admins.
 */
export const Home = () => {
  const canReadAllTimetables = useHasPermission(Actions.Timetable.Read.All);
  return canReadAllTimetables ? (
    <TimetableAdminDashboard />
  ) : (
    <StudentTimetable />
  );
};

export default Home;
